export default function navigation() {
    Alpine.data('navigation',       () => ({
        visible: false,
        currentView: 'pages',
        showNav(){
            this.visible = true;
            document.getElementById('additionalNav').classList.remove('showNav');
            document.querySelector('body').classList.add('overflow-hidden');
        },
        hideNav(){
            this.visible = false;
            document.getElementById('additionalNav').classList.add('showNav');
            document.querySelector('body').classList.remove('overflow-hidden');
        },
        changeView(){
            this.currentView = this.currentView === 'pages' ? 'archive' : 'pages';
        }
    }))
}